var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('commonHead',{on:{"search":_vm.commonHeadSearch}}),_c('wapCommonHead',{on:{"rollback":_vm.rollbackCommon}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"abnormal404-main"},[_c('img',{attrs:{"src":require("../../static/img/404.png")}})])
}]

export { render, staticRenderFns }